function Collection(container) {
  var sectionId = container.getAttribute('data-section-id');
  var Carousel = document.getElementById('glider-carousel-' + sectionId);
  if (Carousel) {
    Sliders(container);
  }  
}

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  Collection(sectionContainer);
})

theme.Collection = (function() {
  function Collection(container) {
    var sectionId = container.getAttribute('data-section-id');
    var l = container.getAttribute('data-layout');
    var aB = document.getElementById('ajaxBusy');
    var ajaxLoadPage = function (url) {
      aB.style.display = 'block';
      fetch(url)
      .then(response => response.text())
      .then(data => {        
        var c = document.getElementById('collection-products');
        var p = document.getElementById('paginateBy');
        var bC = document.querySelector('.breadcrumbs');
        var f = document.getElementById('filters');
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        var nC = htmlDocument.documentElement.querySelector('#collection-products');
        var nP = htmlDocument.documentElement.querySelector('#paginateBy');
        var nBC = htmlDocument.documentElement.querySelector('.breadcrumbs');
        var nF = htmlDocument.documentElement.querySelector('#filters');
        if (c) {
          c.replaceWith(nC);
        }
        if (p) {
          p.replaceWith(nP);
        }
        if (bC) {
          bC.replaceWith(nBC);
        }
        if (f) {
          f.replaceWith(nF);
        }
        imageObserver();
        if (theme.settings.quickView) {
          Quick();
        }
        Wrap();
        filters.action();
        if (l == 'form') {
          check.cart();
          Quantity(container);
          cart.buttons();
        }
        PriceChange();
        Swatches(container);
        if (theme.settings.cart) {
          Cart(container);
        }
        history.replaceState({
          page: url
        }, url, url);
        var s = nC.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top:s-document.selectors.sht, behavior: 'smooth'});
        aB.style.display = 'none';
      }).catch(function (err) {
        console.log('!: ' + err);
      });      
    };
    var filters = {
      action:function (e) {
        var pA = container.querySelectorAll('.paginateBy');
        pA.forEach(function(p) {
          p.onclick = function(ev){                      
            ev.preventDefault();
            var u = new URL(window.location);
            var params = u.searchParams;
            u.search = params.toString();
            var url = u.toString();
            var pag = this.textContent;
            aB.style.display = 'block';
            fetch(theme.routes_cart_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({attributes: {'pagination': pag }})
            }).then(function () {
              ajaxLoadPage(url);
            });
          }
        });        
        var fA = container.querySelectorAll('li.advanced-filter a');
        fA.forEach(function(f) {
          f.onclick = function(ev){                        
            ev.preventDefault();
            var url = f.getAttribute('href');
            ajaxLoadPage(url);
          }
          f.onmouseenter = function(){
            f.classList.add('hover');
          };
          f.onmouseleave = function(){
            f.classList.remove('hover');
          };
        });      
        var dS = container.querySelectorAll('.dropdown select');
        dS.forEach(function(d) {
          d.onchange = function(){
            if (d.value) {
              location.href = d.value;
            }
            else {
              location.href = theme.routes_all_products_collection_url;
            }
          };
        });
        container.querySelector('select.sortBy').onchange = function(s){
          var u = new URL(window.location);
          var params = u.searchParams;
          params.set('sort_by', this.value);
          u.search = params.toString();
          var url = u.toString();
          ajaxLoadPage(url);
        };          
        var iW = document.body.scrollWidth;
        var dO = document.querySelectorAll('.open-container-filter.desktop > details');
        if (iW <= 583) {
          dO.forEach(function(d) {
            d.open = false;
          });
        }            
      }
    };
    if (l == 'form') {
      var check = {
        cart:function (e) {
          fetch(theme.routes_cart_url + '.js')
          .then(function(r) {
            return r.json();
          }).then(function(j) {
            var its = j.items;
            for (i = 0, len = its.length; i < len; i++) {
              let it = its[i],
                  iq = it.quantity,
                  id = it.id,
                  ti = document.getElementById('updates_' + id) || null;
              var er = document.getElementById('error_' + id);
              if (ti) {
                ti.value = iq;
                er.style.display = 'block';
                er.textContent = theme.language.collections_general_update_cart_label_message;
                document.getElementById('variant_' + id).classList.add('item-in-cart');
              }
            }
          });
        }
      }; 
      function cart_change() {
        var it = this.closest('.item');
        var id = it.getAttribute('data-product-id');
        var q =  it.querySelector('.item-qty').value;
        var iQ = it.querySelector('.item-qty');
        var iB = it.querySelectorAll('.qtybtn');
        var s = it.querySelector('.error');
        if (it.classList.contains('item-in-cart')) {
          var u = theme.routes_cart_change_url;
        } else {
          var u = theme.routes_cart_add_url;
        }
        fetch(u + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({'quantity': q,'id':id})
        }).then(function(r) {
          return r.json();
        }).then(function(j) {
          iB.forEach(function(i) {
            i.setAttribute('disabled', true)
          });
          if (j.status == 'bad_request') {
            console.log('Request returned an error', j) 
          } else {            
            CartDrop();
            var v = iQ.value;
            var x = iQ.getAttribute('max');
            if (v < x && v > 0 ) {
            } else if (v == 0) {
              s.style.display = 'none';
              s.html = '';
            }
            if (q > 0) {
              it.classList.add('item-in-cart');
            } else {
              it.classList.remove('item-in-cart');
            }
            iB.forEach(function(i) {
              i.removeAttribute('disabled');
            });
          }
        }).catch(function(err) {
          console.error('!: ' + err)
        });
      }
      var cart = {
        buttons:function (e) {
          var qB = container.querySelectorAll('.qtybtn');
          qB.forEach(function(q) {
            setTimeout(function () {
              q.onclick = cart_change;
            }, 1);
          })
          var qI = container.querySelectorAll('.item-qty');
          qI.forEach(function(q) {
            setTimeout(function () {
              q.addEventListener('input',cart_change);
            }, 1);
          })
        }
      };
      cart.buttons();
    }    
    function PriceChange() {
      var mnV = document.getElementById('price-min');
      var mxV = document.getElementById('price-max');
      var pIN = container.querySelectorAll('.price-input[type="number"]');
      var pIR = container.querySelectorAll('.price-input[type="range"]');
      function PriceChangeType() {
        var u = new URL(window.location);
        var paramsN = u.searchParams;
        var paramsX = u.searchParams;
        paramsN.set(mnV.getAttribute('data-url'), mnV.value);
        paramsX.set(mxV.getAttribute('data-url'), mxV.value);
        u.search = paramsN.toString();
        u.search = paramsX.toString();
        var url = u.toString();
        ajaxLoadPage(url);
      }
      pIN.forEach(function(p) {        
        let timeout;
        p.addEventListener('keyup', function (e) {
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            PriceChangeType();
          }, 750);
        });
      });      
      pIR.forEach(function(p) {
        p.addEventListener('change', PriceChangeType);
      });
    };
    PriceChange();
    filters.action();
    if (l == 'form') {
      check.cart();
      Quantity(container);
    }
    Swatches(container);
    if (theme.settings.cart) {
      Cart(container);
    }
    var popped = ('state' in window.history && window.history.state !== null);
    var initialURL = location.href;
    window.onpopstate = function (e) {
      var initialPop = !popped && location.href == initialURL;
      popped = true;
      if (initialPop) {
        return;
      }
    };
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    Collection.prototype.onSelect = function(ev) {
      if (theme.settings.quickView) {
        Quick();
      }
      Wrap();
    }
  }
  return Collection;
})();